import React from 'react'
import { Box, Grid, Typography } from '@mui/material';
import CompanyLogo from "../../../assets/images/topyacht.svg";
import PublicResultsFooter from './PublicResultsFooter';
const FooterBottom = (logos, banner) => {
    const isLoggedIn = !!localStorage.getItem("accessToken");

    return (
        <Grid container>
            <Box
                sx={{
                    p: 1,
                    // width: isLoggedIn ? '75%' : '100%',
                    width: '100%',
                    // marginBottom: '1rem',
                }}
                className="ty_pr_StikcyFooter"
            >
                <Typography className="result-by">Results By </Typography>
                {/* remove filter: 'drop-shadow(2px 4px 6px black)' after adding topyacht logo  */}
                <img
                    src={CompanyLogo}
                    alt="Banner"
                    style={{
                        // maxWidth: "35%",
                        // maxHeight: "100px",
                        objectFit: "contain",
                    }}
                />
            </Box>
        </Grid>
    )
}

export default FooterBottom
